export default __webpack_public_path__ + "static/summer_containers45-9b728f6071d5c4283d7bedaec4231dd4.webp";